import React, { Component } from "react";
import ActionContainer from "../../../components/UIComponent/ActionTableComponent/actionContainer";
import ActionEditButton from "../../../components/UIComponent/ActionTableComponent/ActionEditButton";
import ActionDeleteButton from "../../../components/UIComponent/ActionTableComponent/ActionDeleteButton";
import { Navigate } from "react-router-dom";
import AuthenticationServices from "../../../services/axiosServices/apiServices/AuthenticationServices";
import SwalServices from "../../../services/swalServices/SwalServices";
import { APIURL, GetImage } from "../../../services/axiosServices/ApiEndPoints";
import { CommonSuccessMessages } from "../../../utils/Messages";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import PageLoader from "../../../components/common/pageLoader/PageLoader";
import { encryptAES } from "../../../utils/Encryption";
import CreateButton from "../../../components/UIComponent/Buttons/CreateButton";
import WebsiteCmsServices from "../../../services/axiosServices/apiServices/WebsiteCmsServices";
import ButtonLoader from "../../../components/common/buttonLoader/ButtonLoader";
import Table from "../../../components/table/Table";
import ActionToggleButton from "../../../components/UIComponent/ActionTableComponent/ActionToggleButton";
import CommunitySpotlightServices from "../../../services/axiosServices/apiServices/CommunitySpotlightServices";
import TextInput from "../../../components/UIComponent/TextInput";
import { DeleteButtonIcon } from "../../../components/SVGConstants";
export default class ManageSpotlights extends Component {
  constructor(props) {
    super(props);
    this.websiteCmsServices = new WebsiteCmsServices();
    this.CommunitySpotlightServices = new CommunitySpotlightServices();
    this.swalServices = new SwalServices();
    this.state = {
      route: "",
      isLoading: false,
      isUpdateLoading: false,
      pagination: {
        pageNo: 1,
        pageSize: 50,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
      },

      publishSpotlightDetails: {
        spotlightId: 0,
        spotlightTitle: "",
        spotlightImage: "",
        redirectionLink: "",
        description: "",
        length: 0,
        orderingPosition: 0,
      },
      length: 0,
      addEditField: false,
      valueOrdering: 0,
      dropdownId: 0,
      totalResultes: 0,
      publishedSpotlightList: [],
      deletedBy: 1,
      deletedAppId: 1,
      featuredWelcomeTitle: "",
    };
  }

  componentDidMount() {
    this.getPublishedSpotlightList();
  }

  getPublishedSpotlightList = (pagination = this.state.pagination) => {
    this.setState({ isLoading: true });
    this.setState({ addEditField: true });

    this.websiteCmsServices
      .getPublishedSpotlightList(pagination)
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          const updatedList =
            response.responseItem.responseContent.itemList.map((item) => ({
              ...item,
              redirectionLink:
                item.redirectionLink && item.redirectionLink.trim() !== ""
                  ? item.redirectionLink
                  : "-",
              IsActive: item.status === "Active",
            }));

          let publishedSpotlights = updatedList;
          publishedSpotlights = publishedSpotlights.map((spotlight) => ({
            spotlightId: spotlight.spotlightId,
            orderingPosition: spotlight.orderingPosition,
            redirectionLink: spotlight.redirectionLink,
            spotlightTitle: spotlight.spotlightTitle,
            status: spotlight.status,
            IsActive: spotlight.IsActive,
          }));
          this.setState({ publishedSpotlightList: publishedSpotlights });
          this.setState({
            length: response.responseItem.responseContent.totalCount + 1,
          });
          this.setState({
            totalResultes: response.responseItem.responseContent.totalCount,
          });

         
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      });
  };

  onDelete = (spotlightId) => {
    if (spotlightId !== null) {
      this.swalServices
        .Confirm(
          CommonSuccessMessages.Confirm_Question.replace("{0}", "Spotlight"),
          CommonSuccessMessages.Confirm_Delete.replace(
            "{0}",
            "spotlight details"
          ),
          CommonSuccessMessages.Yes_Text,
          CommonSuccessMessages.No_Text
        )
        .then((response) => {
          if (response) {
            let request = {};
            request.id = spotlightId;
            request.deletedBy = this.state.deletedBy;
            this.websiteCmsServices
              .deleteSpotlightById(request)
              .then((response) => {
                if (
                  response.statusCode === 200 &&
                  response.responseItem != null
                ) {
                  this.swalServices.Success(
                    "Featured New Member details deleted successfully."
                  );
                  this.getPublishedSpotlightList();
                } else {
                  this.swalServices.Error(response.message);
                }
                this.setState({ isLoading: false });
              });
          }
        });
    } else {
      this.swalServices.Error("Sorry! You can't delete this Member.");
    }
  };

  handleChange(event) {
    const value = event.target.value;
    this.setState({ featuredWelcomeTitle: value });
  }

  searchByName = (value) => {
    let detail = this.state.pagination;
    detail.pageNo = 1;
    detail.pageSize = 10;
    detail.searchText = value;
    this.setState({ pagination: { ...detail } });
    this.getPublishedSpotlightList();
  };

  actions = (element, index, value) => {
    return element !== "spotlightId" ? null : (
      <td>
        <ActionContainer>
          <ActionToggleButton
            className="mr-2"
            index={index}
            data={this.state.publishedSpotlightList}
            onToggleChage={this.onToggleChange.bind(this)}
          />

          <ActionEditButton
            value={value}
            id={index}
            index={index}
            onActionClick={this.onEdit}
            text="Edit"
          />
          <ActionDeleteButton
            value={value}
            id={index}
            index={index}
            onActionClick={this.onDelete}
            text="Delete"
          />
        </ActionContainer>
      </td>
    );
  };

  onEdit = (id) => {
    this.setState({
      route: "/AddEditSpotlight/spotlightId?=" + encryptAES(id),
    });
  };

  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination });
    // this.getbookingsCancellationList(newPagination);
  };

  onToggleChange = (index, event) => {
    let spotlightId = this.state.publishedSpotlightList[index].spotlightId;
    let statusId = 0;
    if (this.state.publishedSpotlightList[index].status === "Inactive") {
      statusId = 1;
    } else if (this.state.publishedSpotlightList[index].status === "Active") {
      statusId = 0;
    }
    this.activeInActiveSpotlights(spotlightId, statusId);
  };

  activeInActiveSpotlights = (id, statusId) => {
    let request = {};
    request.id = id;
    request.statusId = statusId;

    if (request.id > 0 && request.statusId != null) {
      this.websiteCmsServices
        .activeInActiveSpotlights(request)
        .then((response) => {
          if (response.statusCode === 200 && response.responseItem != null) {
            if (response.responseItem.responseContent.hasError === false) {
              this.getPublishedSpotlightList();
            } else {
              this.swalServices.Error(
                response.responseItem.responseContent.errorMessage
              );
            }
          } else {
            this.swalServices.Error(response.message);
          }
        });
    }
  };

  getCommunitySpotlight = (spotlightId) => {
    this.resetManageSpotlightData();
    this.setState({ addEditField: true });
    this.CommunitySpotlightServices.getCommunitySpotlightById(spotlightId).then(
      (response) => {
     
        if (response.statusCode === 200 && response.responseItem != null) {
         
          if (response.responseItem.responseContent != null) {
            this.setState({
              publishSpotlightDetails: response.responseItem.responseContent,
            });

          }
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      }
    );
  };

  resetManageSpotlightData() {
    let details = { ...this.state.publishSpotlightDetails };
    details.orderingPosition = 0;
    details.spotlightId = 0;
    details.spotlightTitle = "";
    details.spotlightImage = "";
    details.redirectionLink = "";
    details.description = "";
    details.status = "";
    this.setState({ publishSpotlightDetails: details });
  }

  cancelAddEditField() {
    this.setState({ addEditField: false });
    this.resetManageSpotlightData();
  }

  addEditCommunitySpotlight = (communitySpotlightId) => {

    this.setState({ addEditField: false });
    let request = {
      spotlightId: communitySpotlightId,
      spotlightTitle: this.state.publishSpotlightDetails.spotlightTitle,
      description: this.state.publishSpotlightDetails.description,
      redirectionLink:
        this.state.publishSpotlightDetails.redirectionLink === null
          ? ""
          : this.state.publishSpotlightDetails.redirectionLink,
      spotlightImage: this.state.publishSpotlightDetails.spotlightImage,
      orderingPosition: this.state.publishSpotlightDetails.orderingPosition,
      // status: this.state.communitySpotlightDetails.status > 0 ? this.state.communitySpotlightDetails.status : 0,
    };

    this.CommunitySpotlightServices.addEditCommunitySpotlight(request).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          if (response.responseItem.responseContent.hasError === false) {
            this.setState({
              addEditCommunitySpotlight: response.AddEditCommunitySpotlight,
            });
            this.swalServices.Success(response.message);
            this.getPublishedSpotlightList();
            // this.setState({ redirect: "/ManageSpotlights" });
          } else {
            this.swalServices.Error(
              response.responseItem.responseContent.errorMessage
            );
          }
          this.setState({ addEditField: false });
        } else {
          this.swalServices.Error(response.message);
        }
      }
    );
  };

  handleChangeForOrderingPosition(event) {
    const value = event.target.value;
    const name = event.target.name;
    let detail = this.state.publishSpotlightDetails;
    if (name === "orderingPosition") {
      let chcklength = this.state.length - 1;
      if (value > chcklength) {
        detail[name] = parseInt(chcklength);
      } else {
        detail[name] = parseInt(value);
      }
    } else {
      detail[name] = value;
    }
    this.setState({ publishSpotlightDetails: detail });
  }

  render() {
    if (this.state.route !== "") {
      return <Navigate to={this.state.route} />;
    }
    return (
      <div className="main-body-section">
        <div className="flex">
          <div className="relative flex flex-col flex-1">
            <main className="pb-10">
              {/* Table Section */}
              <div className="w-full mx-auto">
                <div className="sm:flex sm:justify-between sm:items-center mb-8">
                  <div className="mb-4 sm:mb-0">
                    <h1 className="table-title-txt theme-color font-bold">
                      {this.state.totalResultes} Published Spotlights
                    </h1>
                  </div>
                  <CreateButton
                    redirect="/AddEditSpotlight"
                    text="Create New"
                  />
                </div>
                <div
                  className="relative"
                  tyle={{
                    overflowX: "auto",
                    WebkitOverflowScrolling: "touch",
                    width: "100%",
                  }}
                >
                  {/* <Table columns={[{ name: 'spotlightTitle', title: 'Spotlight Title' },
                                    // { name: 'redirectionLink', title: 'Redirection Link' },
                                    { name: 'orderingPosition', title: 'Ordering Position' }, { name: 'status', title: 'Status' }, { name: 'spotlightId', title: 'Action' }]}
                                        rows={this.state.publishedSpotlightList}
                                        isLoading={this.state.isLoading}
                                        sortingColumns={""}
                                        pagination={this.state.pagination}
                                        totalResultes={this.state.totalResultes}
                                        totalCount={this.state.totalResultes}
                                        setPagination={this.setPagination.bind(this)}
                                        customScope={[

                                            {
                                                column: 'spotlightId',
                                                renderTableData: this.actions.bind(this)
                                            },
                                        ]}
                                        style={{ width: '100%', tableLayout: 'fixed' }}
                                    /> */}

                  <table className="w-full bg-white shadow-lg rounded-sm border border-slate-200">
                    <thead className="table-bg text-xs font-semibold capitalize text-white border-t border-b border-slate-200">
                      <tr>
                        <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[25%]">
                          <div className="font-bold tble-th-txt text-left">
                            Spotlight Title
                          </div>
                        </th>
                        <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[30%]">
                          <div className="font-bold tble-th-txt text-left">
                            Redirection Link
                          </div>
                        </th>
                        <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[30%]">
                          <div className="font-bold tble-th-txt text-left">
                            Status
                          </div>
                        </th>
                        <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[30%]">
                          <div className="font-bold tble-th-txt text-left">
                            Ordering Position
                          </div>
                        </th>
                        <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[15%]">
                          <div className="font-bold tble-th-txt text-left">
                            Action
                          </div>
                        </th>
                      </tr>
                    </thead>
                    {/* {this.state.publishedSpotlightList.map((e, key) => (
                                                <tr key={key}>
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[25%]">
                                                        {e.spotlightTitle}
                                                    </td>
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[25%]">
                                                        {e.redirectionLink}
                                                    </td>

                                                    
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[25%]">
                                                        {e.orderingPosition}
                                                    </td>
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[25%]">
                                                        {e.status}
                                                    </td>
                                                    
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[15%]">
                                                        <ActionContainer>
                                                            <ActionToggleButton
                                                                className="mr-2"
                                                                index={key}
                                                                data={this.state.publishedSpotlightList}
                                                                onToggleChage={this.onToggleChange.bind(this)}
                                                            />

                                                            <ActionEditButton
                                                                value={e.spotlightId}
                                                                id={key}
                                                                index={key}
                                                                onActionClick={this.onEdit}
                                                                text="Edit"
                                                            />
                                                            <ActionDeleteButton
                                                                value={e.spotlightId}
                                                                id={key}
                                                                index={key}
                                                                onActionClick={this.onDelete.bind(this)}
                                                                text="Delete"
                                                            />

                                                        </ActionContainer>
                                                    </td>
                                                </tr>
                                            ))} */}

                    <tbody className="text-sm custom-tbody">
                      {(this.state.publishedSpotlightList &&
                        this.state.publishedSpotlightList.length === 0) ||
                      this.state.publishedSpotlightList.length === null ? (
                        <tr className="">
                          <td
                            className="w-full text-lg text-center py-4 text-[#757575] "
                            colSpan="100%"
                          >
                            No Records Found
                          </td>
                        </tr>
                      ) : (
                        this.state.publishedSpotlightList.map(
                          (dropdown, key) => (
                            <tr key={key}>
                              <td className="px-3 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt pointer text-[#757575] ">
                                <div className="flex flex-col">
                                  <div className="current-text">
                                    {dropdown.spotlightTitle}
                                  </div>
                                </div>
                              </td>
                              <td className="px-3 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt pointer text-[#757575] ">
                                <div className="flex flex-col">
                                  <div className="current-text">
                                    {dropdown.redirectionLink}
                                  </div>
                                </div>
                              </td>
                              <td className="px-3 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt pointer text-[#757575] ">
                                <div className="flex flex-col">
                                  <div className="flex items-center">
                                    <div className="current-text mr-3">
                                      {dropdown.status}
                                    </div>
                                    <ActionToggleButton
                                      className="mr-2"
                                      index={key}
                                      data={this.state.publishedSpotlightList}
                                      onToggleChage={this.onToggleChange.bind(
                                        this
                                      )}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td className="px-3 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt pointer text-[#757575] ">
                                <div className="flex flex-col">
                                  {this.state.addEditField === true &&
                                  this.state.valueOrdering ===
                                    dropdown.orderingPosition &&
                                  this.state.dropdownId ===
                                    dropdown.spotlightId ? (
                                    <div
                                      key={key}
                                      className="flex flex-col relative"
                                    >
                                      <div
                                        className={`edit-field input-height-set center-text`}
                                      >
                                        <TextInput
                                          placeholder=""
                                          type="number"
                                          name="orderingPosition"
                                          max={this.state.length - 1}
                                          value={
                                            this.state.publishSpotlightDetails
                                              .orderingPosition === 0
                                              ? 0
                                              : this.state
                                                  .publishSpotlightDetails
                                                  .orderingPosition
                                          }
                                          handleChange={(event) =>
                                            this.handleChangeForOrderingPosition(
                                              event
                                            )
                                          }
                                          identity="DropdownValueOrdering"
                                          min={0}
                                        />
                                      </div>
                                      <div className="absolute bottom-[-22px]"></div>
                                    </div>
                                  ) : (
                                    <div className="flex items-center gap-3">
                                      <div className="current-text text-center">
                                        {dropdown.orderingPosition}
                                      </div>
                                      <button
                                        className="action-btn mr-4 flex items-center"
                                        aria-controls="add-edit-modal"
                                        onClick={() => {
                                          this.setState(
                                            {
                                              dropdownId: dropdown.spotlightId,
                                              valueOrdering:
                                                dropdown.orderingPosition,
                                            },
                                            () => {
                                              this.getCommunitySpotlight(
                                                dropdown.spotlightId
                                              );
                                            }
                                          );
                                        }}
                                      >
                                        <p className="ml-2 tool-tip-txt underline text-[#757575]">
                                          <svg
                                            className="menu-svg"
                                            width="24"
                                            height="24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 88 88"
                                          >
                                            <g transform="translate(0.000000,88.000000) scale(0.100000,-0.100000)">
                                              <path
                                                d="M645 871 c-11 -5 -142 -132 -290 -282 l-271 -274 -41 -145 c-23 -80 -38 -149 -34 -153 5 -4 74 11 153 34 l146 41 282 283 c332 333 318 302 197 422 -72 72 -105 89 -142 74z m123 -105 c40 -41 72 -79 72 -85 0 -16 -90 -111
                            -104 -111 -6 0 -49 38 -96 85 l-84 85 49 50 c28 29 58 50 70 50 14 0 49 -28 93 -74z m-198 -91 l34 -36 -191 -191 -191 -191 -16 32 c-10 19 -24 31 -36 31 -11 0 -20 3 -20 7 0 9 372 383 380 383 4 0 21 -16 40 -35z m103 -103 l37 -38
                            -194 -187 c-107 -103 -197 -187 -200 -187 -3 0 -6 8 -6 19 0 11 -12 23 -30 31 -16 7 -30 15 -30 19 0 7 373 381 380 381 3 0 23 -17 43 -38z m-488 -320 c12
                            -21 36 -45 58 -57 32 -17 37 -24 35 -49 -3 -25 -9 -31 -48 -42 l-45 -14 -51 53 -51 52 14 48 c12 41 18 47 41 47 21 0 32 -8 47 -38z m-51 -171 c-3 -3 -23 -11 -45 -17 -44 -13 -45 -12 -28 50 l11 38 34 -33 c18 -18 31 -35 28 -38z"
                                                fill="#6e6e6e"
                                              />
                                            </g>
                                          </svg>
                                        </p>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </td>

                              <td className="px-3 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt pointer text-[#757575] ">
                                {this.state.addEditField === true &&
                                this.state.dropdownId ===
                                  dropdown.spotlightId ? (
                                  <div className="flex items-center justify-center edit-field">
                                    <button
                                      className="action-btn mr-4 flex items-center"
                                      aria-controls="add-edit-modal"
                                      onClick={() => {
                                        this.addEditCommunitySpotlight(
                                          dropdown.spotlightId
                                        );
                                      }}
                                    >
                                      <p className="ml-2 tool-tip-txt text-[#329a03] underline cursor-pointer">
                                        Save
                                      </p>
                                    </button>
                                    <button 
                                      className="action-btn mr-4 flex items-center pr-5 min-w-[50px]"
                                      aria-controls="add-edit-modal"
                                      onClick={() => {
                                        this.cancelAddEditField();
                                      }}
                                    >
                                      <img
                                        src="/cancel-icon.png"
                                        className="w-[22px] mx-auto my-0"
                                        alt=""
                                      ></img>
                                    </button>
                                  </div>
                                ) : (
                                  <div className="flex items-center justify-center">
                                    <button
                                      className="action-btn right-icon"
                                      onClick={() =>
                                        this.onDelete(dropdown.spotlightId)
                                      }
                                    >
                                      <DeleteButtonIcon />
                                    </button>

                                    <button
                                      className="ml-2"
                                      onClick={() => {
                                        this.setState({
                                          route:
                                            "/AddEditSpotlight/spotlightId?=" +
                                            encryptAES(dropdown.spotlightId),
                                        });
                                      }}
                                    >
                                      <p>Edit</p>
                                    </button>
                                  </div>
                                )}
                              </td>
                            </tr>
                          )
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}
